import { DatePickerProps } from "antd";
import { DatePicker as AntDatePicker } from "antd";
import classes from "./style.module.css";

export function DatePicker({ className = "", ...rest }: DatePickerProps) {
  const cssNames = [className, classes.datePicker].join(" ");
  return <AntDatePicker {...rest} className={cssNames} />;
}
